import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { STATS_LEADERS_CATEGORY_ARRAY } from '../config/categories';
import '../../../../../store/js/modules/statspro/stats-leaders/reducer/types';
import { useCompetitionNavigationOptions } from '../../../../../../../common/react/hooks/use-competition-navigation-options';
import { Select } from '../../../../../../../common/react/components/Select';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/nav-selector';
import { UPDATE_NAV_ITEM } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { composeGetTranslation } from '../../../../../../../common/react/utils/translations';

const NAV_ITEM_CLASS_NAMES = {
    wrapper: 'stats-leaders-nav-item',
    label: 'stats-leaders-nav-item__label'
};

const getTranslation = composeGetTranslation( 'label.statsLeaders.nav.' );

export const StatsLeadersNav = ( { children } ) => {
    const dispatch = useDispatch();
    const nav = useSelector( statsLeadersNavSelector );

    const { seasons, rounds } = useCompetitionNavigationOptions( {
        competition: nav.competition,
        season: nav.season,
        round: nav.round
    } );
    
    const updateNavSelection = ( navItem, value ) => {
        dispatch( UPDATE_NAV_ITEM.request( { navItem, value } ) );
    };

    return (
        <div className="stats-leaders-nav">
            <div className="stats-leaders-nav__item-wrapper">
                <div className={ NAV_ITEM_CLASS_NAMES.wrapper }>
                    <Select
                        options={ STATS_LEADERS_CATEGORY_ARRAY.map(
                            cat => ( { id: cat, name: cat } )
                        ) }
                        selectedId={ nav.category }
                        id="stats-leaders-category-select"
                        label={ getTranslation( 'category' ) }
                        classNames={ { label: NAV_ITEM_CLASS_NAMES.label } }
                        onChange={ value => updateNavSelection( 'category', value ) }
                    />
                </div>
            </div>
            <div className="stats-leaders-nav__item-wrapper">
                <div className={ NAV_ITEM_CLASS_NAMES.wrapper }>
                    <Select
                        options={ seasons }
                        selectedId={ nav.season.id }
                        id="stats-leaders-season-select"
                        label={ getTranslation( 'season' ) }
                        classNames={ { label: NAV_ITEM_CLASS_NAMES.label } }
                        onChange={ value => {
                            updateNavSelection(
                                'season',
                                { id: parseInt( value.toString() ) }
                            );
                        } }
                    />
                </div>
            </div>
            <div className="stats-leaders-nav__item-wrapper">
                <div className={ NAV_ITEM_CLASS_NAMES.wrapper }>
                    <Select
                        options={ rounds }
                        selectedId={ nav.round.id }
                        id="stats-leaders-round-select"
                        label={ getTranslation( 'round' ) }
                        classNames={ { label: NAV_ITEM_CLASS_NAMES.label } }
                        onChange={ value => {
                            const id = parseInt( value.toString() );
                            updateNavSelection(
                                'round',
                                {
                                    id,
                                    number: rounds.find(
                                        round => round.id === id
                                    ).roundNumber
                                }
                            );
                        } }
                    />
                </div>
            </div>
            { children }
        </div>
    );
};

StatsLeadersNav.propTypes = {
    children: PropTypes.any
};
